import { push } from "connected-react-router"
import React, { FC, ReactChild, useMemo } from "react"
import { useDispatch } from "react-redux"
import { IconAccount, SimpleDropdown } from "dash-styled"
import { useOrgs } from "../../../../../Hooks/useOrgs"
import { useAppState } from "../../../../../Hooks/useReduxState"
import { hasValue } from "../../../../../Models/Client/FetchState"
import { routePaths } from "../../../../../Routes"
import { DashboardBase, DashboardBaseProps } from "./DashboardBase"
import { ReactComponent as TeamIcon } from "icons/lib/team.svg"
import { Redirect } from "react-router"

type OrgDashboardBaseProps = Omit<DashboardBaseProps, "breadcrumbs" | "banner">

const breadcrumbs: string[] = []

export const OrgDashboardBase: FC<OrgDashboardBaseProps> = props => {
    const orgsFetch = useOrgs()
    const dispatch = useDispatch()
    const me = useAppState(state => state.api.authentication.user)
    const orgSwitcher = useMemo<ReactChild>(() => {
        if (
            !hasValue(orgsFetch) ||
            me === null ||
            orgsFetch.value.length === 0
        ) {
            return <></>
        }

        const iconCls = "inline-block w-4 h-4 mr-1 text-rhino-700"
        const orgChoices = [
            {
                value: me.username,
                label: (
                    <div className="pr-8">
                        <IconAccount className={iconCls} />
                        Personal account
                    </div>
                )
            }
        ].concat(
            orgsFetch.value.map(org => ({
                value: org.orgUsername,
                label: (
                    <div className="pr-8">
                        <TeamIcon className={iconCls} />
                        {org.orgUsername}
                    </div>
                )
            }))
        )

        return (
            <SimpleDropdown<string>
                className="z-40 mb-1 mr-auto"
                items={orgChoices}
                title={
                    props.orgUsername === me.username
                        ? "Personal account"
                        : props.orgUsername
                }
                size="md"
                onChange={selected =>
                    dispatch(push(routePaths.orgHome(selected)))
                }
            />
        )
    }, [dispatch, me, orgsFetch, props.orgUsername])

    if (
        me !== null &&
        hasValue(orgsFetch) &&
        props.orgUsername !== me.username &&
        orgsFetch.value.every(o => o.orgUsername !== props.orgUsername)
    ) {
        return <Redirect to={routePaths.dashboard()} />
    }

    return (
        <DashboardBase
            {...props}
            breadcrumbs={breadcrumbs}
            banner={orgSwitcher}
        />
    )
}
